export default __webpack_public_path__ + "static/thumbnail-470888d97f86aefecfb6fdc28bdf21da.jpg";